import { render, staticRenderFns } from "./ListarIndice.vue?vue&type=template&id=4995574c&"
import script from "./ListarIndice.vue?vue&type=script&lang=js&"
export * from "./ListarIndice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports